import React, { useState, useEffect } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import EditCategoryView from '../EditCategoryView/EditCategoryView.jsx'
import EditWorkersView from '../EditWorkersView/EditWorkersView.jsx'
import '../Utils/utils.js'
import { notificationPriorityList } from '../Utils/utils.js'
const NotificationEditView = ({
	jwt,
	show,
	setShow,
	data,
	handleSave,
	editNotification,
	notificationTypes,
	workers,
	workerCategories,
	workCategories,
}) => {
	const [notificationData, setNotificationData] = useState(data)
	const [validated, setValidated] = useState(false)
	const [initialData] = useState(data)
	const [isDataChanged, setIsDataChanged] = useState(false)
	const [showCategoryModal, setShowCategoryModal] = useState(false)
	const [showWorkersModal, setShowWorkersModal] = useState(false)

	useEffect(() => {
		const handleBeforeUnload = (e) => {
			if (isDataChanged) {
				e.preventDefault();
				e.returnValue = 'У вас есть несохраненные изменения. Вы уверены, что хотите уйти?';
				return e.returnValue;
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);
		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [isDataChanged]);

	useEffect(() => {
		const handlePopState = (e) => {
			if (isDataChanged && !window.confirm('У вас есть несохраненные изменения. Вы уверены, что хотите уйти?')) {
				window.history.pushState(null, '', window.location.pathname);
			}
		};

		window.history.pushState(null, '', window.location.pathname);
		window.addEventListener('popstate', handlePopState);

		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [isDataChanged]);

	useEffect(() => {
		if (JSON.stringify(notificationData) !== JSON.stringify(initialData)){
			setIsDataChanged(true);
		}
		else
			setIsDataChanged(false);
	}, [notificationData.message, notificationData.isAction, notificationData.priority, notificationData.workersIdes, notificationData.workerCategoriesIdes, notificationData.type, notificationData.startDate, notificationData.endDate])


	const handleSubmit = event => {
		const form = event.currentTarget
		event.preventDefault()

		if (form.checkValidity() === false) {
			event.stopPropagation()
			setValidated(true)
			return
		}

		if (isDataChanged) {
			handleSave(notificationData)
			editNotification(notificationData)
			setIsDataChanged(false);
			setShow(false);
		}
	}

	const handleClose = () => {
		console.log(isDataChanged == true);
		if (isDataChanged) {
			if (window.confirm('У вас есть несохраненные изменения. Вы уверены, что хотите закрыть без сохранения?')) {
				setShow(false);
				setIsDataChanged(false);
			}
		} else {
			setShow(false)
		}
	}

	return (
		<>
			{showCategoryModal ? (
				<EditCategoryView
					workCategories={workCategories}
					jwt={jwt}
					data={data}
					show={showCategoryModal}
					setShow={setShowCategoryModal}
					setData={setNotificationData}
				/>
			) : (
				''
			)}

			{showWorkersModal ? (
				<EditWorkersView
				    workerCategories={workerCategories}
					workers={workers}
					data={data}
					show={showWorkersModal}
					setShow={setShowWorkersModal}
					setData={setNotificationData}
				/>
			) : (
				''
			)}

			<Modal show={show} onHide={handleClose}>
				<Form noValidate validated={validated} onSubmit={handleSubmit}>
					<Modal.Header>
						<Modal.Title>Редактировать уведомление</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form.Group className='mb-3'>
							<Form.Label>Тип</Form.Label>
							<Form.Select
								value={notificationData?.type}
								onChange={e =>
									setNotificationData({
										...notificationData,
										types: e.target.value,
									})
								}
							>
								{notificationTypes && notificationTypes.length > 0 ? (
									notificationTypes.map((o, id) => (
										<option value={o.key} key={o.id}>
											{o.name}
										</option>
									))
								) : (
									<option>Упс... Типы уведомлений не подгрузились</option>
								)}
							</Form.Select>
							<Form.Control.Feedback type={'invalid'}>
								Обязательно
							</Form.Control.Feedback>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Приоритет</Form.Label>
							<Form.Select
								value={notificationData?.priority}
								onChange={e =>
									setNotificationData({
										...notificationData,
										priority: e.target.value,
									})
								}
							>
								{notificationPriorityList.map((o) => (
									<option value={o.id} key={o.id}>
										{o.name}
									</option>
								))}
							</Form.Select>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Активно</Form.Label>
							<Form.Select
								value={notificationData?.isAction}
								onChange={e =>
									setNotificationData({
										...notificationData,
										isAction: e.target.value,
									})
								}
							>
								<option value='false'>Нет</option>
								<option value='true'>Да</option>
							</Form.Select>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Дата начала</Form.Label>
							<Form.Control
								type='datetime-local'
								value={notificationData?.startDate}
								onChange={e =>
									setNotificationData({
										...notificationData,
										startDate: e.target.value,
									})
								}
							></Form.Control>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Дата конца</Form.Label>
							<Form.Control
								type='datetime-local'
								value={notificationData?.endDate}
								onChange={e =>
									setNotificationData({
										...notificationData,
										endDate: e.target.value,
									})
								}
							></Form.Control>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Работники</Form.Label>
							<br></br>
							<Button variant='info' onClick={() => setShowWorkersModal(true)}>
								Редактировать работников
							</Button>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Категории работ</Form.Label>
							<br></br>
							<Button variant='info' onClick={() => setShowCategoryModal(true)}>
								Редактировать категории работ
							</Button>
						</Form.Group>
						<Form.Group className='mb-3'>
							<Form.Label>Сообщение</Form.Label>
							<Form.Control
								required
								as='textarea'
								rows={3}
								value={notificationData?.message}
								onChange={e =>
									setNotificationData({
										...notificationData,
										message: e.target.value,
									})
								}
							></Form.Control>
							<Form.Control.Feedback type={'invalid'}>
								Обязательно
							</Form.Control.Feedback>
						</Form.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button variant='secondary' onClick={handleClose}>
							Закрыть
						</Button>
						<Button variant='success' type='submit'>
							Сохранить
						</Button>
					</Modal.Footer>
				</Form>
			</Modal>
		</>
	)
}

export default NotificationEditView
